"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAxaptaCustomerProductReturnStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useAxaptaCustomerProductReturnStore = (0, pinia_1.defineStore)('axaptaCustomerProductReturnStore', {
    state: () => ({
        axaptaCustomerProductReturns: [],
        axaptaCustomerProductReturnList: [],
        axaptaId: ''
    }),
    getters: {
        customerProductReturnList: (state) => {
            return state.axaptaCustomerProductReturnList;
        },
        customerProductReturns: (state) => {
            return state.axaptaCustomerProductReturns;
        },
    },
    actions: {
        getCustomerProductReturnList(router, params, customerId) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({
                    name: 'axapta_customer_product_return_list_api',
                    query: {
                        customerId: customerId,
                        ...params
                    }
                }).href)
                    .then((response) => {
                    let axaptaCustomerProductReturnList = [];
                    if (Array.isArray(response)) {
                        response.forEach(element => {
                            axaptaCustomerProductReturnList.push(element);
                        });
                    }
                    this.axaptaCustomerProductReturnList = axaptaCustomerProductReturnList;
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        },
        getCustomerProductReturns(router, params, customerId) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({
                    name: 'axapta_customer_product_returns_api',
                    query: {
                        customerId: customerId,
                        ...params
                    }
                }).href)
                    .then((response) => {
                    let axaptaCustomerProductReturns = [];
                    if (Array.isArray(response)) {
                        response.forEach(element => {
                            axaptaCustomerProductReturns.push(element);
                        });
                    }
                    this.axaptaCustomerProductReturns = axaptaCustomerProductReturns;
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        },
        createCustomerProductReturns(router, customerData, submittedItems) {
            let requestData = {
                customerData: customerData,
                submittedItems: submittedItems
            };
            let options = { body: JSON.stringify(requestData), method: 'POST' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'axapta_create_customer_product_returns_api' }).href, options).then(response => {
                    this.axaptaId = response.Id;
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        removeProductItem(item) {
            const indexToRemove = this.axaptaCustomerProductReturns.findIndex(obj => obj.productId === item.productId);
            this.axaptaCustomerProductReturns.splice(indexToRemove, 1);
        },
        addProductItem(item) {
            this.axaptaCustomerProductReturns.push(item);
        },
        sendCustomerProductReturnCopyInEmail(router, payload) {
            let options = { body: JSON.stringify(payload), method: 'POST' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'axapta_send_customer_product_return_copy_in_email_api' }).href, options)
                    .then(response => {
                    if (response.status !== 'success') {
                        throw Error(response.error);
                    }
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        }
    }
});
